import FormLabel from '@mui/material/FormLabel';
import { useTheme } from '@mui/material/styles';
import React, { FC } from 'react';

import AlertBanner from '@/shared/components/core-ui/alert-banner/alert-banner.component';
import TextField, {
  TextInputType
} from '@/shared/components/core-ui/controls/text-field/text-field.component';
import StyledFormControl from '@/shared/components/core-ui/form/styled-components/styled-form-control';

interface TextInputProps {
  data: {
    name: string;
    placeholder: string;
    label: string;
    value: string | number | null;
    error?: string | null;
    endAdornmentText?: string | React.SVGProps<SVGSVGElement>;
    formLabelHeader?: { en: string; ar: string } | string;
  };
  config?: {
    type?: TextInputType;
    isArabic?: boolean;
    isDisabled?: boolean;
    isMultiLine?: boolean;
    isRequired?: boolean;
  };
  eventHandlers: {
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
}

const FormTextInput: FC<TextInputProps> = ({ data, config = {}, eventHandlers }) => {
  const { name, label, value, error = null, placeholder, endAdornmentText, formLabelHeader } = data;
  const { isArabic, type, isDisabled, isMultiLine, isRequired } = config;
  const { handleInputChange } = eventHandlers;

  const theme = useTheme();

  return (
    <StyledFormControl>
      {typeof formLabelHeader === 'object' && (formLabelHeader?.en || formLabelHeader?.ar) && (
        <AlertBanner data={{ formLabelHeader }} />
      )}
      {typeof formLabelHeader === 'string' && <AlertBanner data={{ formLabelHeader }} />}

      <FormLabel>
        {label} <span>{isRequired ? '*' : ''}</span>
      </FormLabel>
      <TextField
        data={{ name, placeholder, value, error, endAdornmentText }}
        config={{ isArabic, type, isDisabled, isMultiLine, isRequired }}
        eventHandlers={{ handleInputChange }}
      />
    </StyledFormControl>
  );
};

export default FormTextInput;
